export const normalizeEmail = (email: string): string => {
  return email.toLowerCase();
}
